module.exports = __webpack_public_path__ + "static/media/baflix.eef73b00.png";